import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy text-ivory grid place-items-center px-6 noise-overlay">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md border border-white/10 bg-midnight/60 p-8 lg:p-10"
      >
        <Link to="/" data-testid="admin-back-home" className="inline-flex items-center gap-2 text-ivory/50 hover:text-gold text-sm mb-8">
          <ArrowLeft size={16} /> Back to site
        </Link>
        <div className="flex items-center gap-3 mb-2">
          <span className="grid place-items-center w-10 h-10 border border-gold/40 text-gold rounded-full"><Lock size={18} /></span>
          <div>
            <span className="font-serif text-xl text-ivory">KRV</span>
            <span className="font-serif text-xl text-gold">Nexus</span>
          </div>
        </div>
        <h1 className="font-serif font-light text-4xl mt-6">Admin Access</h1>
        <p className="text-ivory/50 text-sm mt-2">Sign in to manage enquiries.</p>

        <form onSubmit={submit} data-testid="admin-login-form" className="mt-8 space-y-6">
          <label className="block">
            <span className="text-xs uppercase tracking-[0.15em] text-ivory/50">Email</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              className="mt-2 w-full bg-transparent border-b border-white/20 py-3 text-ivory focus:outline-none focus:border-gold transition-colors" placeholder="admin@krvnexus.com" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-[0.15em] text-ivory/50">Password</span>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
              className="mt-2 w-full bg-transparent border-b border-white/20 py-3 text-ivory focus:outline-none focus:border-gold transition-colors" placeholder="••••••••" />
          </label>
          {error && <p data-testid="login-error" className="text-red-400 text-sm">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-gold text-navy py-4 rounded-full font-medium hover:bg-gold-muted transition-colors disabled:opacity-60">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
